// extracted by mini-css-extract-plugin
export default {"badge":"BadgeNouveau_badge__DjAKO","cliquable":"BadgeNouveau_cliquable__mNxJd"};